import SvgIcon from '@components/SvgIcon'
import { FunctionComponent } from 'react'
import styled, { css, useTheme } from 'styled-components'

interface SubmittedOverlayProps {
  submitted: boolean
}

const StyledSubmittedOverlay = styled.div<{ isVisible: boolean }>`
  ${({ isVisible }) =>
    isVisible
      ? css`
          z-index: 1;
          display: block;
          position: absolute;
          height: 100%;
          width: 100%;
          top: 0;
          left: 0;
          right: 0;
          display: flex;
          flex-direction: column;
          justify-content: end;
        `
      : css`
          display: none;
        `}
`

const Feedback = styled.div`
  ${({
    theme: {
      colors: { fillWeak, textDefault },
      typography: {
        catchword: {
          medium2: { bundledCSS: medium2CatchwordCSS },
        },
      },
      spacing: { spacing40, spacing8, spacing12 },
    },
  }) => css`
    padding: 0 ${spacing12};
    background-color: ${fillWeak};
    height: ${spacing40};
    display: flex;
    align-items: center;
    color: ${textDefault};
    ${medium2CatchwordCSS};

    svg {
      margin-right: ${spacing8};
    }
  `}
`

const SubmittedOverlay: FunctionComponent<SubmittedOverlayProps> = ({
  submitted,
}) => {
  const theme = useTheme()
  return (
    <StyledSubmittedOverlay isVisible={submitted}>
      {submitted && (
        <Feedback>
          <SvgIcon
            iconName={'circle-check'}
            size={32}
            color={theme.colors.iconDefault}
          />
          Vielen Dank für deinen Beitrag!
        </Feedback>
      )}
    </StyledSubmittedOverlay>
  )
}

export default SubmittedOverlay
